export const boundingBoxNetherlands = [3.35, 50.74, 7.24, 53.558];
